import { render, staticRenderFns } from "./message-cloud.vue?vue&type=template&id=74353ca0&"
import script from "./message-cloud.vue?vue&type=script&lang=js&"
export * from "./message-cloud.vue?vue&type=script&lang=js&"
import style0 from "./message-cloud.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74353ca0')) {
      api.createRecord('74353ca0', component.options)
    } else {
      api.reload('74353ca0', component.options)
    }
    module.hot.accept("./message-cloud.vue?vue&type=template&id=74353ca0&", function () {
      api.rerender('74353ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/message-cloud.vue"
export default component.exports